import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import { API_BASE_URL } from './config'; // Import the API base URL
import ArticleList from './ArticleList'; // Import the new ArticleList component

interface Article {
  id: number;
  title: string;
  description: string;
  url: string;
  published_at: string;
  positivity: number;
  image_url: string;
}

interface CategoryProps {
  sliderValue: number; // New prop for slider value
}

const categoryMap: { [key: string]: string } = {
  Domaci: 'domácí',
  Zahranicni: 'zahraničí',
  Ekonomika: 'ekonomika',
  Technika: 'technika',
  Kultura: 'kultura',
  Sport: 'sport',
};

const displayCategoryMap: { [key: string]: string } = {
  Domaci: 'Domácí',
  Zahranicni: 'Zahraniční',
  Ekonomika: 'Ekonomika',
  Technika: 'Technika',
  Kultura: 'Kultura',
  Sport: 'Sport',
};

const Category: React.FC<CategoryProps> = ({ sliderValue }) => { // Receive sliderValue
  const { categoryName } = useParams<{ categoryName: string }>();
  const [articles, setArticles] = useState<Article[]>([]);
  const [visibleCount, setVisibleCount] = useState(10); // New state for visible articles

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get(API_BASE_URL, {
          params: { 
            category: categoryMap[categoryName || ''],
            positivity: sliderValue, // Add positivity
            limit: 50, // Updated limit to fetch 50 articles
          },
        });
        setArticles(response.data);
        setTimeout(() => {
          document.querySelectorAll('.article').forEach(article => {
            article.classList.add('loaded');
          });
        }, 100); // Delay to ensure articles are rendered before adding the class
      } catch (error) {
        console.error(error);
      }
    };

    fetchArticles();
  }, [categoryName, sliderValue]); // Add sliderValue as dependency

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 500 &&
        visibleCount < articles.length
      ) {
        setVisibleCount(prev => Math.min(prev + 10, articles.length)); // Load next 10 articles
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleCount, articles.length]);

  return (
    <>
      <div className="page-container">
        <h2>{displayCategoryMap[categoryName || '']}</h2>
        <ArticleList articles={articles.slice(0, visibleCount)} /> {/* Display only visible articles */}
      </div>
    </>
  );
};

export default Category;
